export default __webpack_public_path__ + "static/media/our-partner-logo-7.5adbb61f.svg";